webpackJsonp([20],{

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("72a63148", content, true);

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".reset[data-v-c5e08dbc]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/ResetPassword.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB","file":"ResetPassword.vue","sourcesContent":["\n.reset[data-v-c5e08dbc] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var components_inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ResetPassword.vue





/* harmony default export */ var ResetPassword = ({
  props: {
    platformName: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      error: {},
      form: {
        email: null
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'skiliko/password/isLoading'
  }), {
    inputs: function inputs() {
      var _this = this;

      return [{ key: 'password', required: true, component: components_inputs["t" /* TextInput */], type: 'password' }, { key: 'confirmation', required: true, component: components_inputs["t" /* TextInput */], type: 'password' }].map(function (input) {
        var data = { terms: _this.terms, privacy: _this.privacy };
        return extends_default()({}, input, {
          label: _this.$t('pages.resetpassword.labels.' + input.key, data),
          errors: (_this.error[input.key] || []).map(function (e) {
            return function () {
              return e;
            };
          })
        });
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    reset: 'skiliko/password/reset'
  }), {
    submit: function submit() {
      var _this2 = this;

      this.reset({
        token: this.token,
        password: this.form.password,
        passwordConfirmation: this.form.confirmation,
        platformName: this.platformName
      }).then(function (_) {
        return _this2.$router.replace({ path: _this2.$route.query.redirect || '/' });
      }).catch(function (_ref) {
        var response = _ref.response;
        return _this2.error = (response || {}).data || {};
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5e08dbc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ResetPassword.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"reset"},[_c('v-card-title',[_vm._v("\n      "+_vm._s(_vm.$t('pages.resetpassword.title'))+"\n    ")]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._l((_vm.inputs),function(input){return _c(input.component,{key:input.key,tag:"component",attrs:{"config":input},model:{value:(_vm.form[input.key]),callback:function ($$v) {_vm.$set(_vm.form, input.key, $$v)},expression:"form[input.key]"}})}),_vm._v(" "),(_vm.error.reset_password_token)?_c('v-btn',{attrs:{"block":"","outline":"","primary":"","light":"","router":"","href":{ name: 'ForgotPassword' }}},[_vm._v("\n          "+_vm._s(_vm.$t('pages.resetpassword.forgot'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","block":"","ripple":"","loading":_vm.loading}},[_vm._v("\n          "+_vm._s(_vm.$t('pages.resetpassword.submit'))+"\n        ")])],2)])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"error":"","multi-line":""},model:{value:(_vm.error.reset_password_token),callback:function ($$v) {_vm.$set(_vm.error, "reset_password_token", $$v)},expression:"error.reset_password_token"}},[_vm._v(_vm._s(_vm.$t('pages.resetpassword.passwordTokenError')))]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","flat":"","light":"","router":"","href":{ name: 'Login' }}},[_vm._v(_vm._s(_vm.$t('pages.resetpassword.login')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_ResetPassword = (esExports);
// CONCATENATED MODULE: ./src/pages/ResetPassword.vue
function injectStyle (ssrContext) {
  __webpack_require__(961)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5e08dbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ResetPassword,
  pages_ResetPassword,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_ResetPassword = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/20.d7b95b7f993655e7951c.js